export default {
  methods: {
    $errors_showNetworkErrorMessage() {
      this.$notifications_error(this.$t('Server error'));
    },
    $errors_go404() {
      this.$router.push({ name: 'Page404' });
    },
    $errors_go500() {
      this.$router.push({ name: 'Page500' });
    },
  },
};
